import { render, staticRenderFns } from "./MyHome.vue?vue&type=template&id=e2ba31f6&scoped=true&"
import script from "./MyHome.vue?vue&type=script&lang=js&"
export * from "./MyHome.vue?vue&type=script&lang=js&"
import style0 from "./MyHome.vue?vue&type=style&index=0&id=e2ba31f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ba31f6",
  null
  
)

export default component.exports